import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ManagerProxyDto } from '../../../api';
import { queryKeys } from '../../../constants';
import useAuthenticatedClients from '../../../hooks/useAuthenticatedClients';
import { onMutationError } from '../../../utils/Utils';
import { useQuery } from 'react-query';

function ManagerProxyQueries() {
  const { MANAGER_PROXY_QUERY_KEY, REPORTING_EMPLOYEES_QUERY_KEY, PROXY_USER_OPTIONS_QUERY_KEY } = queryKeys;
  const { getManagerProxyClient, getEmployeesClient } = useAuthenticatedClients();
  const queryClient = useQueryClient();

  const { mutate: mutateCreateManagerProxy } = useMutation<ManagerProxyDto, Error, ManagerProxyDto>(
    createManagerProxy,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(MANAGER_PROXY_QUERY_KEY);
        toast.success('Successfully created manager proxy');
      },
      onError: onMutationError,
    }
  );

  const { mutate: mutateDeleteManagerProxy } = useMutation<void, Error, number>(deleteManagerProxy, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(MANAGER_PROXY_QUERY_KEY);
      toast.success('Successfully deleted manager proxy');
    },
    onError: onMutationError,
  });

  async function createManagerProxy(managerProxyDto: ManagerProxyDto) {
    const client = await getManagerProxyClient();
    const project = await client.createManagerProxy(managerProxyDto);
    return project;
  }

  async function deleteManagerProxy(id: number) {
    const client = await getManagerProxyClient();
    await client.deleteManagerProxy(id);
  }

  const FetchManagerProxies = () => {
    const result = useQuery(MANAGER_PROXY_QUERY_KEY, async () => {
      return await getManagerProxyClient().then(client => client.getManagerProxies());
    });
    return result;
  };

  const FetchReportingEmployees = () => {
    const result = useQuery(REPORTING_EMPLOYEES_QUERY_KEY, async () => {
      return await getEmployeesClient().then(client => client.getReportingEmployees());
    });
    return result;
  };

  const FetchProxyUserOptions = () => {
    const result = useQuery(PROXY_USER_OPTIONS_QUERY_KEY, async () => {
      return await getEmployeesClient().then(client => client.getProxyUserOptions());
    });
    return result;
  };

  return {
    mutateCreateManagerProxy,
    mutateDeleteManagerProxy,
    FetchManagerProxies,
    FetchReportingEmployees,
    FetchProxyUserOptions,
  };
}

export default ManagerProxyQueries;
